import {
    faBarcode,
    faFileInvoiceDollar,
    faHandHoldingUsd,
    faHandshake,
    faReceipt,
    faRetweet,
    faScroll,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useUserInfor } from "../../../../../Context/User";
import { IDadosERP } from "../../../../../Interfaces/Geral/ERP/ERPInterface";
import ExtradoDoCliente from "../../../../../Pages/Cobranca/Atendimento/ExtratoDoCliente";
import { ExtratoIRPf } from "../../../../../Pages/Cobranca/Atendimento/ModalExtratoIRPF";
import Renegociacao from "../../../../../Pages/Cobranca/Atendimento/Renegociacao";
import { ACESSOS } from "../../../../../Routes/Acessos";
import BigActionButton from "../../../../Buttons/BigActionButton";
import ModalComponent from "../../../../Modais";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import AtualizarStatusEscrituraVendaDoCaso from "../../../AtualizarStatusEscrituraVendaDoCaso";
import GerarBoletoModal from "../../../GerarBoletoModal";
import LancamentoCustas from "../../../LancamentoCustas";
import AlterarStatusCobranca from "../../../AlterarStatusCobranca";
import RenegociacaoSienge from "../../../../../Pages/Cobranca/Atendimento/RenegociacaoSienge";

interface IAcoesERPProps {
    dadosERP: IDadosERP;
}

export default function AcoesERP(props: IAcoesERPProps) {
    const AtendimentoPageContext = useAtendimentoPage();
    const Atendimento = AtendimentoPageContext.Atendimento!;

    const { OrgInfor, Config } = useUserInfor();
    const { FUNCOES } = useUserInfor().UserInfor;
    const boletosTitle =
        OrgInfor.COD_ERP_INTEGRACAO === "SIENGE" ? "Boletos" : "Gerar Boleto";
    const totvsMode = OrgInfor.COD_ERP_INTEGRACAO === "TOTVS";
    const eSolutionMode =
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION_LIVA" ||
        OrgInfor.COD_ERP_INTEGRACAO === "ESOLUTION";
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    const { dadosERP } = props;

    return (
        <div className="card card-custom px-8 py-4 mb-5">
            <h4 className="text-center mb-0">Ações do ERP</h4>
            <hr />
            <div className="g-5  d-flex flex-row flex-wrap justify-content-center">
                {FUNCOES.some((f) => f.NM_FUNCAO === "ADM_GERAR_BOLETO") && (
                    <BigActionButton
                        icon={faBarcode}
                        color="success"
                        onClick={() => {
                            if (dadosERP) {
                                setShow(true);
                                setModal({
                                    Component: () => (
                                        <GerarBoletoModal
                                            ID_CONTA={Atendimento.ID_CONTA}
                                            parcelasRequest={dadosERP}
                                            ID_CASO={Atendimento.ID_CASO}
                                            empreendimento={
                                                Atendimento.DS_PRODUTO_COMP?.split(
                                                    "-"
                                                )?.[0] ?? ""
                                            }
                                            unidade={
                                                Atendimento.DS_PRODUTO_COMP?.split(
                                                    "-"
                                                )?.[2] ?? ""
                                            }
                                        />
                                    ),
                                    headerComponent: boletosTitle,
                                    IconHeader: faBarcode,
                                    noFooter: true,
                                    noBody: true,
                                    size: "xl",
                                    scrollable: true,
                                });
                            }
                        }}
                    >
                        {boletosTitle}
                    </BigActionButton>
                )}
                {FUNCOES.some((f) => f.NM_FUNCAO === "ADM_EXTRATO_CLIENTE") && (
                    <BigActionButton
                        icon={faReceipt}
                        color="primary"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Extrato Cliente",
                                IconHeader: faReceipt,
                                Component: () => (
                                    <ExtradoDoCliente
                                        Atendimento={{
                                            ...Atendimento,
                                            ...dadosERP,
                                            ID_EMPRESA:
                                                dadosERP?.NR_EMPRESA ?? 0,
                                        }}
                                        setShow={setShow}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        Extrato Cliente
                    </BigActionButton>
                )}
                {FUNCOES.some((f) => f.NM_FUNCAO === "ADM_EXTRATO_IR") &&
                    !totvsMode &&
                    !eSolutionMode && (
                        <BigActionButton
                            icon={faFileInvoiceDollar}
                            color="info"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Extrato IRPF",
                                    IconHeader: faFileInvoiceDollar,
                                    Component: () => (
                                        <ExtratoIRPf
                                            Atendimento={{
                                                ...Atendimento,
                                                ...dadosERP,
                                                ID_EMPRESA:
                                                    dadosERP?.NR_EMPRESA ?? 0,
                                            }}
                                            setShow={setShow}
                                        />
                                    ),
                                    size: "lg",
                                });
                            }}
                        >
                            Extrato IR
                        </BigActionButton>
                    )}

                {FUNCOES.some(
                    (f) => f.NM_FUNCAO === "ADM_REGISTRAR_ACORDO"
                ) && (
                    <>
                        {Config.ConfigCobrancaDTO
                            .FL_COB_PERMITE_REGISTRAR_ACORDO &&
                            OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                                <BigActionButton
                                    color="danger"
                                    icon={faHandshake}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent: "Registrar Acordo",
                                            IconHeader: faHandshake,
                                            Component: () => (
                                                <Renegociacao
                                                    DS_OBRA={dadosERP.DS_OBRA}
                                                    NR_EMPRESA={
                                                        dadosERP.NR_EMPRESA
                                                    }
                                                    NR_VENDA={dadosERP.NR_VENDA}
                                                    idProduto={
                                                        Atendimento.ID_PRODUTO
                                                    }
                                                    idCaso={Atendimento.ID_CASO}
                                                    setShow={setShow}
                                                />
                                            ),
                                            size: "xl",
                                        });
                                    }}
                                >
                                    Registrar Acordo
                                </BigActionButton>
                            )}

                        {Config.ConfigCobrancaDTO
                            .FL_COB_PERMITE_REGISTRAR_ACORDO &&
                            OrgInfor.COD_ERP_INTEGRACAO === "SIENGE" && (
                                <BigActionButton
                                    color="danger"
                                    icon={faHandshake}
                                    onClick={() => {
                                        setShow(true);
                                        setModal({
                                            headerComponent:
                                                "Reparcelamento de um Título",
                                            IconHeader: faHandshake,
                                            Component: () => (
                                                <RenegociacaoSienge
                                                    DS_OBRA={dadosERP.DS_OBRA}
                                                    NR_EMPRESA={
                                                        dadosERP.NR_EMPRESA
                                                    }
                                                    NR_VENDA={dadosERP.NR_VENDA}
                                                    idProduto={
                                                        Atendimento.ID_PRODUTO
                                                    }
                                                    idCaso={Atendimento.ID_CASO}
                                                    setShow={setShow}
                                                />
                                            ),
                                            size: "xl",
                                        });
                                    }}
                                >
                                    Registrar Acordo
                                </BigActionButton>
                            )}
                    </>
                )}

                {FUNCOES.some((f) => f.NM_FUNCAO === "ADM_LANCAMENTO_CUSTAS") &&
                    !AtendimentoPageContext.bloquearInteracoes &&
                    Config.ConfigCobrancaDTO
                        .FL_COB_PERMITE_INSERIR_LANCAMENTO_CUSTA &&
                    OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                        <BigActionButton
                            color="warning"
                            icon={faHandHoldingUsd}
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Lançamento Custas",
                                    IconHeader: faHandHoldingUsd,
                                    Component: () => (
                                        <LancamentoCustas
                                            empresa={dadosERP.NR_EMPRESA.toString()}
                                            obra={dadosERP.DS_OBRA}
                                            venda={dadosERP.NR_VENDA.toString()}
                                            idCaso={Atendimento.ID_CASO}
                                            idTipoCaso={
                                                ACESSOS.COBRANCA.ID_MODULO
                                            }
                                            setShow={setShow}
                                        />
                                    ),
                                    size: "xl",
                                });
                            }}
                        >
                            Lançamento de Custas
                        </BigActionButton>
                    )}

                {FUNCOES.some((f) => f.NM_FUNCAO === "ADM_STATUS_ESCRITURA") &&
                    OrgInfor.COD_ERP_INTEGRACAO === "UAU" &&
                    Atendimento.ID_CHAVE_ERP_VENDA && (
                        <BigActionButton
                            icon={faScroll}
                            color="primary"
                            style={{
                                width: 90,
                                height: 90,
                                borderRadius: 15,
                            }}
                            className="btn btn-outline-primary d-flex flex-column align-items-center justify-content-center g-1"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent:
                                        "Atualizar Status de Escritura da Venda",
                                    IconHeader: faScroll,
                                    Component: () => (
                                        <AtualizarStatusEscrituraVendaDoCaso
                                            ID_CHAVE_ERP={
                                                Atendimento.ID_CHAVE_ERP_VENDA!
                                            }
                                            setShow={setShow}
                                        />
                                    ),
                                    size: "xl",
                                });
                            }}
                        >
                            Status de Escritura
                        </BigActionButton>
                    )}

                {FUNCOES.some(
                    (f) => f.NM_FUNCAO === "ADM_ALTERAR_STATUS_COBRANCA"
                ) &&
                    Config.ConfigCobrancaDTO.FL_ALTERAR_STATUS_COBRANCA &&
                    OrgInfor.COD_ERP_INTEGRACAO === "UAU" && (
                        <BigActionButton
                            color="dark"
                            icon={faRetweet}
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent:
                                        "Alterar Status da Cobrança",
                                    IconHeader: faRetweet,
                                    Component: () => (
                                        <AlterarStatusCobranca
                                            ID_CHAVE_ERP_VENDA={
                                                Atendimento.ID_CHAVE_ERP_VENDA
                                            }
                                            setShow={setShow}
                                        />
                                    ),
                                    size: "sm",
                                });
                            }}
                        >
                            <span style={{ fontSize: "9px" }}>
                                Alterar Status Cobrança
                            </span>
                        </BigActionButton>
                    )}

                <ModalComponent
                    show={show}
                    setShow={setShow}
                    ModalComponent={modal}
                />
            </div>
        </div>
    );
}
